import { faNote, type IconDefinition } from "@fortawesome/pro-light-svg-icons";

import { type AllergenName } from "~/api/products/types";

import { type AllergenLanguageCode, ALLERGENS_LIST } from "./constants";

function isAllergenName(name: string): name is AllergenName {
  return ALLERGENS_LIST.some((allergen) => allergen.key === name);
}

type GetAllergenInfoArgs = {
  name: string;
  languageCode: AllergenLanguageCode;
};

type GetAllergenInfoResult = {
  key: string;
  label: string;
  faIcon?: IconDefinition;
  iconImage?: string;
};

export function getAllergenInfo({
  name,
  languageCode
}: GetAllergenInfoArgs): GetAllergenInfoResult {
  const allergen = ALLERGENS_LIST.find((allergen) => allergen.key === name);
  if (!isAllergenName(name) || !allergen) {
    return {
      key: name,
      label: name,
      faIcon: faNote
    };
  }

  const allergenParentName = allergen.key.split(":")[0];

  return {
    key: allergen.key,
    label: allergen.names[languageCode],
    faIcon: "faIcon" in allergen ? allergen.faIcon : undefined,
    iconImage:
      "faIcon" in allergen
        ? undefined
        : `https://storage.googleapis.com/kanpla-87be3.appspot.com/allergenIcons/${allergenParentName}.svg`
  };
}
